// โลโก้แบรนด์: ใช้รูปจริง (logoUrl) ถ้ามี ไม่งั้นเป็นตัวอักษรบนพื้นสีของแบรนด์
//
// รูปโลโก้หลายตัวเป็น URL จาก CDN ของ Facebook ที่หมดอายุได้ จึงต้องมีตัวอักษรสำรอง
// เสมอ ไม่ปล่อยให้เห็นกรอบรูปแตก · โครง DOM/คลาสตรงกับ brandLogoHtml() เดิม
// เพื่อให้หน้าใหม่กับหน้าเก่าที่ยังเสิร์ฟคู่กันหน้าตาเหมือนกันเป๊ะ
import { useState } from "react";
import type { Brand } from "@contracts/api";
import { cn } from "@shared/lib/utils";

type Props = {
  brand: Pick<Brand, "name" | "color" | "logoUrl">;
  /** ขนาดต่างกันตามที่ใช้: brand-logo (การ์ด) · mini-logo (dropdown) */
  className: string;
};

export function BrandLogo({ brand, className }: Props) {
  const [imgFailed, setImgFailed] = useState(false);
  const letter = (brand.name || "?").charAt(0);

  if (brand.logoUrl) {
    return (
      <span className={cn(className, "logo-box")}>
        <img
          src={brand.logoUrl}
          alt=""
          loading="lazy"
          onError={() => setImgFailed(true)}
          style={imgFailed ? { display: "none" } : undefined}
        />
        {/* .logo-fallback ถูก display:none ไว้ใน CSS — โชว์เฉพาะตอนรูปโหลดไม่ขึ้น */}
        <span className="logo-fallback" style={imgFailed ? { display: "grid" } : undefined}>
          {letter}
        </span>
      </span>
    );
  }
  return (
    <span className={className} style={{ background: brand.color }}>
      {letter}
    </span>
  );
}
